var map = {
	"./assets/icons/CO2.svg": 49108,
	"./assets/icons/DMS.svg": 11228,
	"./assets/icons/ELD.svg": 3769,
	"./assets/icons/Exclude.svg": 77466,
	"./assets/icons/Ice-cream.svg": 92908,
	"./assets/icons/access-is-denied.svg": 59365,
	"./assets/icons/access-right.svg": 16699,
	"./assets/icons/air.svg": 51520,
	"./assets/icons/alcoholic_drinks_bottle.svg": 53951,
	"./assets/icons/america.svg": 24496,
	"./assets/icons/arrow-bottom-top.svg": 9375,
	"./assets/icons/arrow-down.svg": 26292,
	"./assets/icons/arrow-push.svg": 41692,
	"./assets/icons/arrow-right.svg": 48150,
	"./assets/icons/arrow-top.svg": 98849,
	"./assets/icons/asset-utilization-report.svg": 3686,
	"./assets/icons/avoidable_operating_costs.svg": 95196,
	"./assets/icons/basket.svg": 8346,
	"./assets/icons/battery-lvl-100.svg": 69508,
	"./assets/icons/battery-lvl-25.svg": 82040,
	"./assets/icons/battery-lvl-50.svg": 91704,
	"./assets/icons/battery-lvl-75.svg": 51691,
	"./assets/icons/battery-report.svg": 72178,
	"./assets/icons/biochemical.svg": 22334,
	"./assets/icons/ble_tag.svg": 1554,
	"./assets/icons/bluetooth-icon-90.svg": 6326,
	"./assets/icons/bluetooth-icon.svg": 78172,
	"./assets/icons/bluetooth-indicator.svg": 9518,
	"./assets/icons/bluetooth-rotate-90.svg": 39208,
	"./assets/icons/bluetooth-station.svg": 47733,
	"./assets/icons/bluetooth.svg": 69442,
	"./assets/icons/bread.svg": 22470,
	"./assets/icons/buble-arrow.svg": 44370,
	"./assets/icons/build-track.svg": 38726,
	"./assets/icons/butter.svg": 39922,
	"./assets/icons/button_edit.svg": 18867,
	"./assets/icons/button_units_on_map.svg": 62911,
	"./assets/icons/cakes.svg": 71923,
	"./assets/icons/calendar.svg": 7590,
	"./assets/icons/camera-offline.svg": 40127,
	"./assets/icons/camera-online.svg": 94035,
	"./assets/icons/camera.svg": 16049,
	"./assets/icons/car-back.svg": 57502,
	"./assets/icons/car-front.svg": 24664,
	"./assets/icons/car-l-side.svg": 35163,
	"./assets/icons/car-r-side.svg": 28641,
	"./assets/icons/car.svg": 90918,
	"./assets/icons/car_.svg": 349,
	"./assets/icons/cargo-temperature.svg": 82489,
	"./assets/icons/cargo.svg": 12328,
	"./assets/icons/cell_tower.svg": 622,
	"./assets/icons/charge.svg": 12800,
	"./assets/icons/chart-line.svg": 59267,
	"./assets/icons/chart-schedule.svg": 34566,
	"./assets/icons/chart.svg": 42204,
	"./assets/icons/checkbox_bold.svg": 39299,
	"./assets/icons/cheese.svg": 96155,
	"./assets/icons/chocolates.svg": 48541,
	"./assets/icons/circle-done.svg": 8009,
	"./assets/icons/circle-wait.svg": 48130,
	"./assets/icons/circle__BLE-connect.svg": 33980,
	"./assets/icons/circle__BLE-disconnect.svg": 26768,
	"./assets/icons/circle___geozone_circle.svg": 17925,
	"./assets/icons/circle___geozone_circle_hidden.svg": 77964,
	"./assets/icons/circle__a-point.svg": 64914,
	"./assets/icons/circle__accelerate.svg": 88133,
	"./assets/icons/circle__b-point.svg": 88833,
	"./assets/icons/circle__clock-2.svg": 17917,
	"./assets/icons/circle__clock.svg": 34416,
	"./assets/icons/circle__coords.svg": 8512,
	"./assets/icons/circle__d-point.svg": 27279,
	"./assets/icons/circle__hidden.svg": 82706,
	"./assets/icons/circle__hourglass.svg": 18832,
	"./assets/icons/circle__link.svg": 26514,
	"./assets/icons/circle__lost-connection.svg": 46905,
	"./assets/icons/circle__low-battery.svg": 94576,
	"./assets/icons/circle__max-speed.svg": 26686,
	"./assets/icons/circle__message.svg": 11415,
	"./assets/icons/circle__mileage.svg": 95118,
	"./assets/icons/circle__movement.svg": 36381,
	"./assets/icons/circle__number.svg": 7209,
	"./assets/icons/circle__parking.svg": 30198,
	"./assets/icons/circle__pin.svg": 71183,
	"./assets/icons/circle__radius.svg": 13260,
	"./assets/icons/circle__satellit-2.svg": 24157,
	"./assets/icons/circle__satellit.svg": 52144,
	"./assets/icons/circle__shock.svg": 59580,
	"./assets/icons/circle__shown.svg": 76421,
	"./assets/icons/circle__signal.svg": 17650,
	"./assets/icons/circle__speed.svg": 62747,
	"./assets/icons/circle__speed_lg.svg": 73357,
	"./assets/icons/circle__steering-wheel.svg": 19541,
	"./assets/icons/circle__stop.svg": 90322,
	"./assets/icons/circle__turn.svg": 29679,
	"./assets/icons/circle__video-event.svg": 82872,
	"./assets/icons/clock.svg": 52878,
	"./assets/icons/close.svg": 36456,
	"./assets/icons/collapse.svg": 99353,
	"./assets/icons/command__active.svg": 81743,
	"./assets/icons/command__block.svg": 42548,
	"./assets/icons/command__delete.svg": 91400,
	"./assets/icons/command__edit.svg": 34357,
	"./assets/icons/command__follow.svg": 87114,
	"./assets/icons/command__history-key.svg": 86133,
	"./assets/icons/command__history-order.svg": 6224,
	"./assets/icons/command__history.svg": 79263,
	"./assets/icons/command__key_revoke.svg": 98567,
	"./assets/icons/command__key_suspend.svg": 27783,
	"./assets/icons/command__password.svg": 80918,
	"./assets/icons/command__refresh.svg": 42874,
	"./assets/icons/command__restore.svg": 2761,
	"./assets/icons/command__sign_in_admin.svg": 86084,
	"./assets/icons/command__sign_in_portal.svg": 41881,
	"./assets/icons/command__update_key.svg": 1186,
	"./assets/icons/common__add.svg": 71266,
	"./assets/icons/common__add_lg.svg": 57618,
	"./assets/icons/common__add_sm.svg": 73821,
	"./assets/icons/common__boat.svg": 11771,
	"./assets/icons/common__boat_lg.svg": 79341,
	"./assets/icons/common__bus.svg": 8913,
	"./assets/icons/common__bus_lg.svg": 58663,
	"./assets/icons/common__buy.svg": 82232,
	"./assets/icons/common__car.svg": 68177,
	"./assets/icons/common__car_lg.svg": 167,
	"./assets/icons/common__chat.svg": 43991,
	"./assets/icons/common__checkbox.svg": 12270,
	"./assets/icons/common__checkbox_all.svg": 48078,
	"./assets/icons/common__chevron_down.svg": 27133,
	"./assets/icons/common__chevron_left.svg": 68934,
	"./assets/icons/common__chevron_left_double.svg": 53406,
	"./assets/icons/common__chevron_right.svg": 63365,
	"./assets/icons/common__chevron_right_double.svg": 32159,
	"./assets/icons/common__chevron_up.svg": 98466,
	"./assets/icons/common__clear_lg.svg": 74504,
	"./assets/icons/common__clear_sm.svg": 37971,
	"./assets/icons/common__close.svg": 92851,
	"./assets/icons/common__close_sm.svg": 34486,
	"./assets/icons/common__collapse.svg": 42264,
	"./assets/icons/common__command.svg": 87376,
	"./assets/icons/common__complex.svg": 10891,
	"./assets/icons/common__complex_lg.svg": 79197,
	"./assets/icons/common__copy.svg": 80742,
	"./assets/icons/common__copy_sm.svg": 59481,
	"./assets/icons/common__delete.svg": 38912,
	"./assets/icons/common__delete_lg.svg": 12252,
	"./assets/icons/common__delete_sm.svg": 72111,
	"./assets/icons/common__docs.svg": 18236,
	"./assets/icons/common__dry_tanker.svg": 24114,
	"./assets/icons/common__dry_trailer.svg": 12460,
	"./assets/icons/common__dry_trailer_lg.svg": 61448,
	"./assets/icons/common__edit.svg": 33709,
	"./assets/icons/common__edit_lg.svg": 50899,
	"./assets/icons/common__email.svg": 59515,
	"./assets/icons/common__engine.svg": 54999,
	"./assets/icons/common__engine_lg.svg": 26201,
	"./assets/icons/common__exit.svg": 53393,
	"./assets/icons/common__export.svg": 27539,
	"./assets/icons/common__export_sm.svg": 90294,
	"./assets/icons/common__favorite.svg": 24169,
	"./assets/icons/common__filter.svg": 1639,
	"./assets/icons/common__filter_on.svg": 47965,
	"./assets/icons/common__follow_sm.svg": 72813,
	"./assets/icons/common__ftp.svg": 25905,
	"./assets/icons/common__fuel_tank.svg": 51672,
	"./assets/icons/common__fuel_tank_lg.svg": 27876,
	"./assets/icons/common__fuel_tanker.svg": 42013,
	"./assets/icons/common__fuel_tanker_lg.svg": 4259,
	"./assets/icons/common__generator.svg": 68456,
	"./assets/icons/common__generator_lg.svg": 94356,
	"./assets/icons/common__geozone_all-geozones.svg": 64727,
	"./assets/icons/common__geozone_circle.svg": 13845,
	"./assets/icons/common__geozone_corridor.svg": 82115,
	"./assets/icons/common__geozone_polygon.svg": 23261,
	"./assets/icons/common__history.svg": 887,
	"./assets/icons/common__ignition.svg": 39852,
	"./assets/icons/common__import_export.svg": 80551,
	"./assets/icons/common__info.svg": 60613,
	"./assets/icons/common__info1.svg": 4558,
	"./assets/icons/common__info_link.svg": 20392,
	"./assets/icons/common__jet_ski.svg": 42300,
	"./assets/icons/common__jet_ski_lg.svg": 68984,
	"./assets/icons/common__line-close.svg": 49872,
	"./assets/icons/common__location.svg": 39476,
	"./assets/icons/common__locator.svg": 79989,
	"./assets/icons/common__menu_sm.svg": 30603,
	"./assets/icons/common__more.svg": 39730,
	"./assets/icons/common__more_vertical.svg": 32935,
	"./assets/icons/common__motorcycle.svg": 48162,
	"./assets/icons/common__motorcycle_lg.svg": 86290,
	"./assets/icons/common__movement.svg": 85078,
	"./assets/icons/common__notice.svg": 83657,
	"./assets/icons/common__notice_disabled.svg": 85188,
	"./assets/icons/common__online_notifications.svg": 47049,
	"./assets/icons/common__parking.svg": 71971,
	"./assets/icons/common__password.svg": 69198,
	"./assets/icons/common__pin.svg": 41254,
	"./assets/icons/common__pin_disabled.svg": 99821,
	"./assets/icons/common__plant_machine.svg": 4490,
	"./assets/icons/common__plant_machine_lg.svg": 66218,
	"./assets/icons/common__print_sm.svg": 84065,
	"./assets/icons/common__pump.svg": 57803,
	"./assets/icons/common__pump_lg.svg": 7389,
	"./assets/icons/common__reefer_gt.svg": 8956,
	"./assets/icons/common__reefer_gt_lg.svg": 8376,
	"./assets/icons/common__reefer_trailer.svg": 38130,
	"./assets/icons/common__reefer_trailer_lg.svg": 24514,
	"./assets/icons/common__remove_lg.svg": 78595,
	"./assets/icons/common__remove_sm.svg": 30268,
	"./assets/icons/common__reports.svg": 95654,
	"./assets/icons/common__resend_sm.svg": 58351,
	"./assets/icons/common__rv.svg": 70397,
	"./assets/icons/common__rv_lg.svg": 94019,
	"./assets/icons/common__server-connection.svg": 45661,
	"./assets/icons/common__server-no-connection.svg": 83569,
	"./assets/icons/common__settings.svg": 90922,
	"./assets/icons/common__show.svg": 18386,
	"./assets/icons/common__show_disabled.svg": 37913,
	"./assets/icons/common__show_partially.svg": 41117,
	"./assets/icons/common__signal.svg": 23521,
	"./assets/icons/common__signal_lost.svg": 65886,
	"./assets/icons/common__slider.svg": 30702,
	"./assets/icons/common__stationary_unit.svg": 59368,
	"./assets/icons/common__stationary_unit_lg.svg": 20244,
	"./assets/icons/common__status_favorite.svg": 52542,
	"./assets/icons/common__status_not_notify.svg": 82047,
	"./assets/icons/common__status_not_show.svg": 87935,
	"./assets/icons/common__status_notice_close.svg": 52995,
	"./assets/icons/common__status_pin.svg": 38511,
	"./assets/icons/common__status_tracking.svg": 59473,
	"./assets/icons/common__support.svg": 61642,
	"./assets/icons/common__tank.svg": 52629,
	"./assets/icons/common__tank_lg.svg": 49131,
	"./assets/icons/common__track.svg": 92126,
	"./assets/icons/common__track_day.svg": 27745,
	"./assets/icons/common__tracking.svg": 91322,
	"./assets/icons/common__tracking_disabled.svg": 14081,
	"./assets/icons/common__tractor.svg": 57238,
	"./assets/icons/common__tractor_lg.svg": 97222,
	"./assets/icons/common__train.svg": 41793,
	"./assets/icons/common__train_lg.svg": 60599,
	"./assets/icons/common__truck.svg": 35042,
	"./assets/icons/common__truck_lg.svg": 86578,
	"./assets/icons/common__upgrade.svg": 46675,
	"./assets/icons/common__user.svg": 352,
	"./assets/icons/common__user_sm.svg": 48815,
	"./assets/icons/common__van.svg": 66508,
	"./assets/icons/common__van_lg.svg": 48680,
	"./assets/icons/common__video.svg": 35994,
	"./assets/icons/common__warning.svg": 67743,
	"./assets/icons/common__water_tanker.svg": 17032,
	"./assets/icons/common__water_tanker_lg.svg": 26580,
	"./assets/icons/common__zoom.svg": 27756,
	"./assets/icons/cookies.svg": 86945,
	"./assets/icons/customization.svg": 55391,
	"./assets/icons/danger.svg": 47349,
	"./assets/icons/direction_track.svg": 98247,
	"./assets/icons/dns-error.svg": 83924,
	"./assets/icons/document.svg": 23759,
	"./assets/icons/download-video-2.svg": 80091,
	"./assets/icons/download-video.svg": 55162,
	"./assets/icons/download.svg": 81468,
	"./assets/icons/download_documents.svg": 82147,
	"./assets/icons/driver-1.svg": 81564,
	"./assets/icons/driver.svg": 80070,
	"./assets/icons/drivers-score-card.svg": 7667,
	"./assets/icons/edit_notes.svg": 12142,
	"./assets/icons/eggs.svg": 19586,
	"./assets/icons/eld_battery.svg": 38179,
	"./assets/icons/eld_clock.svg": 82054,
	"./assets/icons/eld_driver.svg": 27182,
	"./assets/icons/eld_status_D.svg": 24247,
	"./assets/icons/eld_status_S.svg": 81320,
	"./assets/icons/empty.svg": 88591,
	"./assets/icons/engine.svg": 42554,
	"./assets/icons/engine_badge.svg": 95870,
	"./assets/icons/error-image-photo-icon.svg": 11197,
	"./assets/icons/eta-fill.svg": 75598,
	"./assets/icons/eta-track.svg": 25470,
	"./assets/icons/eta.svg": 61724,
	"./assets/icons/event_temperature.svg": 36867,
	"./assets/icons/expand.svg": 11284,
	"./assets/icons/favorite.svg": 98760,
	"./assets/icons/file-color.svg": 67120,
	"./assets/icons/file.svg": 91838,
	"./assets/icons/fish.svg": 2578,
	"./assets/icons/flowers.svg": 37592,
	"./assets/icons/from.svg": 81692,
	"./assets/icons/fruits.svg": 74685,
	"./assets/icons/fuel-filling.svg": 58054,
	"./assets/icons/fuel.svg": 2504,
	"./assets/icons/general-status.svg": 40111,
	"./assets/icons/generator-off.svg": 86011,
	"./assets/icons/generator-ok.svg": 6658,
	"./assets/icons/generator-powel-grid.svg": 30230,
	"./assets/icons/generator-switch.svg": 95624,
	"./assets/icons/geozones-visits-report.svg": 33584,
	"./assets/icons/gps.svg": 15768,
	"./assets/icons/group-on-map.svg": 99944,
	"./assets/icons/head__logo.svg": 22961,
	"./assets/icons/help__add_car_icon.svg": 21001,
	"./assets/icons/help__geoitems1_icon.svg": 52817,
	"./assets/icons/help__geoitems_icon.svg": 63150,
	"./assets/icons/help__login_icon.svg": 69970,
	"./assets/icons/help__notices_icon.svg": 18278,
	"./assets/icons/help__settings_icon.svg": 32768,
	"./assets/icons/help__track_icon.svg": 83700,
	"./assets/icons/help__unit_icon.svg": 69811,
	"./assets/icons/http-no-ssl.svg": 78273,
	"./assets/icons/http-ssl.svg": 47781,
	"./assets/icons/https-no-ssl.svg": 21504,
	"./assets/icons/https-ssl.svg": 94538,
	"./assets/icons/icon-dialog.svg": 47880,
	"./assets/icons/ignition-off.svg": 74565,
	"./assets/icons/ignition-on.svg": 10513,
	"./assets/icons/img-icon.svg": 31261,
	"./assets/icons/input.svg": 47160,
	"./assets/icons/input__date.svg": 5622,
	"./assets/icons/input__select-2.svg": 5667,
	"./assets/icons/input__select-3.svg": 91026,
	"./assets/icons/input__select-4.svg": 24957,
	"./assets/icons/input__select.svg": 14290,
	"./assets/icons/intuit-logo.svg": 7085,
	"./assets/icons/item-gradient.svg": 31106,
	"./assets/icons/lamp.svg": 24418,
	"./assets/icons/line-1.svg": 55744,
	"./assets/icons/link.svg": 46052,
	"./assets/icons/list-item-1.svg": 78954,
	"./assets/icons/loading-dns.svg": 48526,
	"./assets/icons/location-point.svg": 61916,
	"./assets/icons/locator-icon.svg": 80068,
	"./assets/icons/logo.svg": 62921,
	"./assets/icons/maintenance.svg": 78953,
	"./assets/icons/maintenance_fuel.svg": 93856,
	"./assets/icons/maintenance_notifications.svg": 45040,
	"./assets/icons/maintenance_table.svg": 97872,
	"./assets/icons/maintenance_tracking.svg": 75807,
	"./assets/icons/malanka.svg": 21975,
	"./assets/icons/manually-start-shipment.svg": 12783,
	"./assets/icons/map-point-fill.svg": 65943,
	"./assets/icons/map-point.svg": 40059,
	"./assets/icons/map__car_type_ambulance.svg": 24562,
	"./assets/icons/map__car_type_container.svg": 85025,
	"./assets/icons/map__car_type_fire-fighter-woman.svg": 75289,
	"./assets/icons/map__car_type_fire-fighter.svg": 6140,
	"./assets/icons/map__car_type_flatbed.svg": 31710,
	"./assets/icons/map__car_type_k9.svg": 98292,
	"./assets/icons/map__car_type_law-men.svg": 10739,
	"./assets/icons/map__car_type_law-women.svg": 45693,
	"./assets/icons/map__car_type_motorbike.svg": 40320,
	"./assets/icons/map__car_type_paramedics-women.svg": 66442,
	"./assets/icons/map__car_type_paramedics.svg": 96391,
	"./assets/icons/map__car_type_pickup.svg": 20256,
	"./assets/icons/map__car_type_police-car.svg": 2123,
	"./assets/icons/map__car_type_police.svg": 62806,
	"./assets/icons/map__car_type_reefer.svg": 53639,
	"./assets/icons/map__car_type_sedan.svg": 18577,
	"./assets/icons/map__car_type_taxi.svg": 97568,
	"./assets/icons/map__car_type_trailer.svg": 61013,
	"./assets/icons/map__car_type_truck.svg": 97573,
	"./assets/icons/map__pin-bles.svg": 82660,
	"./assets/icons/md_fuel.svg": 74882,
	"./assets/icons/md_ignition.svg": 91071,
	"./assets/icons/md_mileage.svg": 84902,
	"./assets/icons/md_move.svg": 75521,
	"./assets/icons/md_offline.svg": 86963,
	"./assets/icons/md_stop.svg": 36698,
	"./assets/icons/md_traffic.svg": 26465,
	"./assets/icons/md_violations.svg": 80598,
	"./assets/icons/meat.svg": 86685,
	"./assets/icons/medicines.svg": 6567,
	"./assets/icons/menu-lines.svg": 71491,
	"./assets/icons/menu__alarm.svg": 99634,
	"./assets/icons/menu__alarm_fill.svg": 74982,
	"./assets/icons/menu__analytics.svg": 79101,
	"./assets/icons/menu__analytics_fill.svg": 92555,
	"./assets/icons/menu__car.svg": 45495,
	"./assets/icons/menu__car_fill.svg": 76489,
	"./assets/icons/menu__dashboard.svg": 66013,
	"./assets/icons/menu__dashboard_fill.svg": 19179,
	"./assets/icons/menu__dealer.svg": 50088,
	"./assets/icons/menu__dealer_fill.svg": 31288,
	"./assets/icons/menu__delete.svg": 93626,
	"./assets/icons/menu__delete_fill.svg": 50462,
	"./assets/icons/menu__fuel.svg": 62075,
	"./assets/icons/menu__fuel_cards.svg": 45619,
	"./assets/icons/menu__fuel_cards_fill.svg": 83037,
	"./assets/icons/menu__fuel_fill.svg": 75797,
	"./assets/icons/menu__gauges.svg": 94215,
	"./assets/icons/menu__gauges_fill.svg": 48793,
	"./assets/icons/menu__geoitem_add.svg": 4519,
	"./assets/icons/menu__geoitems.svg": 92958,
	"./assets/icons/menu__geoitems_fill.svg": 71194,
	"./assets/icons/menu__hamburger.svg": 82468,
	"./assets/icons/menu__help.svg": 60346,
	"./assets/icons/menu__help_fill.svg": 19614,
	"./assets/icons/menu__history.svg": 34665,
	"./assets/icons/menu__history_fill.svg": 86751,
	"./assets/icons/menu__keys.svg": 29171,
	"./assets/icons/menu__keys_fill.svg": 58621,
	"./assets/icons/menu__maintenance.svg": 4948,
	"./assets/icons/menu__maintenance_fill.svg": 17292,
	"./assets/icons/menu__md.svg": 22664,
	"./assets/icons/menu__md_fill.svg": 98776,
	"./assets/icons/menu__more.svg": 32620,
	"./assets/icons/menu__more_fill.svg": 19636,
	"./assets/icons/menu__notifications.svg": 98129,
	"./assets/icons/menu__notifications_fill.svg": 5495,
	"./assets/icons/menu__passengers.svg": 15716,
	"./assets/icons/menu__passengers_fill.svg": 87932,
	"./assets/icons/menu__personnel.svg": 40285,
	"./assets/icons/menu__personnel_fill.svg": 33131,
	"./assets/icons/menu__proHub.svg": 51401,
	"./assets/icons/menu__proHub2.svg": 22297,
	"./assets/icons/menu__proHub2_fill.svg": 3055,
	"./assets/icons/menu__proHub_fill.svg": 31839,
	"./assets/icons/menu__prometheus.svg": 43207,
	"./assets/icons/menu__prometheus_fill.svg": 40505,
	"./assets/icons/menu__reports.svg": 73260,
	"./assets/icons/menu__reports_fill.svg": 48596,
	"./assets/icons/menu__routes.svg": 44377,
	"./assets/icons/menu__routes_fill.svg": 99247,
	"./assets/icons/menu__shipment.svg": 87237,
	"./assets/icons/menu__shipment_fill.svg": 54531,
	"./assets/icons/menu__statistic.svg": 19531,
	"./assets/icons/menu__statistic_fill.svg": 29957,
	"./assets/icons/menu__tracks.svg": 72723,
	"./assets/icons/menu__tracks_fill.svg": 54589,
	"./assets/icons/menu__undefined.svg": 33693,
	"./assets/icons/menu__undefined_fill.svg": 11947,
	"./assets/icons/menu__units-groups.svg": 46149,
	"./assets/icons/menu__units-groups_fill.svg": 90467,
	"./assets/icons/menu__user-profile.svg": 46750,
	"./assets/icons/menu__user-profile_fill.svg": 19450,
	"./assets/icons/menu__video.svg": 94344,
	"./assets/icons/menu__video_fill.svg": 19032,
	"./assets/icons/microphone-available.svg": 31694,
	"./assets/icons/microphone-not-available.svg": 15446,
	"./assets/icons/microphone.svg": 91348,
	"./assets/icons/mileage-circle.svg": 99805,
	"./assets/icons/milk.svg": 36365,
	"./assets/icons/money_cart.svg": 26485,
	"./assets/icons/munit.png": 97458,
	"./assets/icons/no-image.svg": 70845,
	"./assets/icons/non-alcoholic.svg": 44076,
	"./assets/icons/notifications__approaching_geopoint.svg": 14922,
	"./assets/icons/notifications__approaching_object.svg": 54924,
	"./assets/icons/notifications__complex-logic.svg": 74527,
	"./assets/icons/notifications__distance_geopoint.svg": 17349,
	"./assets/icons/notifications__drain.svg": 27604,
	"./assets/icons/notifications__empty.svg": 48305,
	"./assets/icons/notifications__fuel_control.svg": 68852,
	"./assets/icons/notifications__geozone.svg": 79831,
	"./assets/icons/notifications__geozone_entrance_control.svg": 814,
	"./assets/icons/notifications__geozone_exit_control.svg": 28228,
	"./assets/icons/notifications__input-.svg": 79767,
	"./assets/icons/notifications__input.svg": 75294,
	"./assets/icons/notifications__input_alert.svg": 60985,
	"./assets/icons/notifications__lost-connection.svg": 75673,
	"./assets/icons/notifications__lost_connection.svg": 42615,
	"./assets/icons/notifications__low-battery.svg": 63280,
	"./assets/icons/notifications__maintenance.svg": 24859,
	"./assets/icons/notifications__max-speed.svg": 76958,
	"./assets/icons/notifications__movement.svg": 39037,
	"./assets/icons/notifications__overspeeding_gis.svg": 76961,
	"./assets/icons/notifications__parameter_control.svg": 91413,
	"./assets/icons/notifications__parking.svg": 43254,
	"./assets/icons/notifications__refill.svg": 5598,
	"./assets/icons/notifications__sensor_control.svg": 73450,
	"./assets/icons/notifications__stop.svg": 24402,
	"./assets/icons/notifications__towing.svg": 47772,
	"./assets/icons/notifications__video-event.svg": 75544,
	"./assets/icons/notifications_warning.svg": 48397,
	"./assets/icons/obd__coolant_temperature.svg": 18876,
	"./assets/icons/obd__cumulative_fuel_economy.svg": 61484,
	"./assets/icons/obd__fuel_level.svg": 26068,
	"./assets/icons/obd__mileage.svg": 53217,
	"./assets/icons/obd__rpm.svg": 58178,
	"./assets/icons/obd__speed.svg": 816,
	"./assets/icons/ocean.svg": 76910,
	"./assets/icons/ok.svg": 88794,
	"./assets/icons/open-new-tab.svg": 811,
	"./assets/icons/other.svg": 56818,
	"./assets/icons/output.svg": 67667,
	"./assets/icons/output_.svg": 4206,
	"./assets/icons/outputs-text-1.svg": 67164,
	"./assets/icons/outputs-text-2.svg": 69487,
	"./assets/icons/panels.svg": 73217,
	"./assets/icons/pen.svg": 24717,
	"./assets/icons/photo.svg": 88104,
	"./assets/icons/play-button.svg": 57175,
	"./assets/icons/playback__video-event-1.svg": 53107,
	"./assets/icons/playback__video-event-2.svg": 62368,
	"./assets/icons/playback__video-event-3.svg": 19281,
	"./assets/icons/playback__video-group.svg": 38440,
	"./assets/icons/playback__warn-event.svg": 55290,
	"./assets/icons/pm-logo.svg": 25095,
	"./assets/icons/posted-speed-limit-report.svg": 76228,
	"./assets/icons/product_1_month.svg": 61106,
	"./assets/icons/product_1_year.svg": 97771,
	"./assets/icons/product_3_month.svg": 74288,
	"./assets/icons/product_6_month.svg": 41157,
	"./assets/icons/products_bg.svg": 85170,
	"./assets/icons/rail.svg": 50116,
	"./assets/icons/reefer-active-zone.svg": 38589,
	"./assets/icons/reefer-battery.svg": 77551,
	"./assets/icons/reefer-cooling.svg": 13621,
	"./assets/icons/reefer-defrost.svg": 50797,
	"./assets/icons/reefer-dor-close.svg": 4032,
	"./assets/icons/reefer-dor-open.svg": 21820,
	"./assets/icons/reefer-error.svg": 61706,
	"./assets/icons/reefer-evaporator.svg": 92277,
	"./assets/icons/reefer-failed.svg": 39671,
	"./assets/icons/reefer-heat.svg": 93414,
	"./assets/icons/reefer-info-1.svg": 65754,
	"./assets/icons/reefer-info-2.svg": 33865,
	"./assets/icons/reefer-info-3.svg": 29624,
	"./assets/icons/reefer-info-4.svg": 18807,
	"./assets/icons/reefer-info-5.svg": 4422,
	"./assets/icons/reefer-loading.svg": 21908,
	"./assets/icons/reefer-mode.svg": 76249,
	"./assets/icons/reefer-ok.svg": 22566,
	"./assets/icons/reefer-power-off.svg": 7683,
	"./assets/icons/reefer-status.svg": 14534,
	"./assets/icons/reefer-success.svg": 85337,
	"./assets/icons/reefer-supply.svg": 77257,
	"./assets/icons/reefer-temperature.svg": 38814,
	"./assets/icons/reefer-trailer.svg": 33233,
	"./assets/icons/reefer-wizard.svg": 11325,
	"./assets/icons/reefer.svg": 80591,
	"./assets/icons/reefer__fuel.svg": 89557,
	"./assets/icons/reefer__mode.svg": 58076,
	"./assets/icons/reefer__temperatura.svg": 71473,
	"./assets/icons/reefer_fish.svg": 20376,
	"./assets/icons/refeer__coil.svg": 88762,
	"./assets/icons/refeer__malanka.svg": 2842,
	"./assets/icons/refeer__wind.svg": 94825,
	"./assets/icons/reports.svg": 79629,
	"./assets/icons/reports_alarms.svg": 76902,
	"./assets/icons/reports_driving.svg": 75633,
	"./assets/icons/reports_fuel.svg": 22724,
	"./assets/icons/reports_idling.svg": 8175,
	"./assets/icons/reports_parkings.svg": 27635,
	"./assets/icons/reports_raw.svg": 3234,
	"./assets/icons/reports_statistics.svg": 53001,
	"./assets/icons/reports_trips.svg": 48520,
	"./assets/icons/road.svg": 91454,
	"./assets/icons/search.svg": 17928,
	"./assets/icons/segment__full_full_full.svg": 95762,
	"./assets/icons/segment__full_half_half.svg": 52226,
	"./assets/icons/send-to-cloud.svg": 17808,
	"./assets/icons/send_insurance.svg": 87843,
	"./assets/icons/sensor__address.svg": 3856,
	"./assets/icons/sensors__battary_voltage.svg": 45297,
	"./assets/icons/sensors__battery.svg": 71022,
	"./assets/icons/sensors__co2_level.svg": 10054,
	"./assets/icons/sensors__co_level.svg": 23206,
	"./assets/icons/sensors__fuel_level.svg": 54312,
	"./assets/icons/sensors__humidity.svg": 70724,
	"./assets/icons/sensors__illumination.svg": 66998,
	"./assets/icons/sensors__oil_pressure.svg": 43825,
	"./assets/icons/sensors__rpm.svg": 27558,
	"./assets/icons/sensors__temperature.svg": 29443,
	"./assets/icons/sensors__voltage.svg": 93499,
	"./assets/icons/services.svg": 52348,
	"./assets/icons/settings.svg": 72979,
	"./assets/icons/shield-done.svg": 88760,
	"./assets/icons/shield-wait.svg": 24883,
	"./assets/icons/shipment-scan-code.svg": 28238,
	"./assets/icons/shipment.svg": 27738,
	"./assets/icons/shipment__box.svg": 70183,
	"./assets/icons/shipment__container.svg": 94217,
	"./assets/icons/shipment__documents.svg": 83006,
	"./assets/icons/shipment__food.svg": 12664,
	"./assets/icons/shipment__group.svg": 20101,
	"./assets/icons/shipment__mail.svg": 75641,
	"./assets/icons/shipment__pallet.svg": 67506,
	"./assets/icons/shipment__pallete.svg": 30064,
	"./assets/icons/shipment__point.svg": 78518,
	"./assets/icons/shipment__temperature.svg": 90314,
	"./assets/icons/shipment_reports.svg": 18262,
	"./assets/icons/shipments-package.svg": 44778,
	"./assets/icons/ssl.svg": 51462,
	"./assets/icons/status_fuel.svg": 89269,
	"./assets/icons/status_mileage.svg": 72555,
	"./assets/icons/status_move.svg": 5078,
	"./assets/icons/status_none.svg": 53983,
	"./assets/icons/status_offline.svg": 30214,
	"./assets/icons/status_online.svg": 3460,
	"./assets/icons/status_stop.svg": 94777,
	"./assets/icons/status_traffic.svg": 38336,
	"./assets/icons/status_violations.svg": 52185,
	"./assets/icons/tab-fuel.svg": 27254,
	"./assets/icons/tag_not-registered.svg": 1535,
	"./assets/icons/timeline.svg": 48645,
	"./assets/icons/to.svg": 55767,
	"./assets/icons/trailer.svg": 70989,
	"./assets/icons/tropical-plants.svg": 69283,
	"./assets/icons/unauthorized-parking-report.svg": 33628,
	"./assets/icons/unit-list-humidity.svg": 49699,
	"./assets/icons/unit-list-shock.svg": 18634,
	"./assets/icons/unit-list-temp.svg": 98670,
	"./assets/icons/unit-list-temperature.svg": 58778,
	"./assets/icons/unit__reefer.svg": 44715,
	"./assets/icons/unit_dashboard__address-point.svg": 39610,
	"./assets/icons/unit_dashboard__battery.svg": 88828,
	"./assets/icons/unit_dashboard__charge.svg": 54629,
	"./assets/icons/unit_dashboard__check.svg": 72195,
	"./assets/icons/unit_dashboard__check_danger.svg": 80171,
	"./assets/icons/unit_dashboard__check_null.svg": 8897,
	"./assets/icons/unit_dashboard__humidity.svg": 65230,
	"./assets/icons/unit_dashboard__ignition.svg": 71528,
	"./assets/icons/unit_dashboard__main_power.svg": 47596,
	"./assets/icons/unit_dashboard__massage.svg": 30966,
	"./assets/icons/unit_dashboard__mileage.svg": 24591,
	"./assets/icons/unit_dashboard__online.svg": 37968,
	"./assets/icons/unit_dashboard__speed.svg": 36398,
	"./assets/icons/unit_dashboard__status.svg": 76171,
	"./assets/icons/unit_dashboard__temperature.svg": 86113,
	"./assets/icons/unit_type_container.svg": 53357,
	"./assets/icons/unit_type_flatbed.svg": 42202,
	"./assets/icons/unit_type_reefer.svg": 62675,
	"./assets/icons/unit_type_trailer.svg": 913,
	"./assets/icons/unit_type_truck.svg": 54233,
	"./assets/icons/units-groups.svg": 51166,
	"./assets/icons/units__ignition_bg.svg": 14616,
	"./assets/icons/units__ignition_symbol.svg": 10653,
	"./assets/icons/units__moving_bg.svg": 19773,
	"./assets/icons/units__moving_symbol.svg": 6400,
	"./assets/icons/units__parking_bg.svg": 41677,
	"./assets/icons/units__parking_symbol.svg": 69520,
	"./assets/icons/user.svg": 65733,
	"./assets/icons/vaccines.svg": 26215,
	"./assets/icons/vector-down.svg": 97070,
	"./assets/icons/vector-top.svg": 33015,
	"./assets/icons/vegetables.svg": 67612,
	"./assets/icons/vide-event_cyclist-collision.svg": 28672,
	"./assets/icons/vide-event_distracted.svg": 95473,
	"./assets/icons/vide-event_pedestrian-collision.svg": 74796,
	"./assets/icons/video-camera.svg": 62847,
	"./assets/icons/video-event_acceleration.svg": 5537,
	"./assets/icons/video-event_accident.svg": 4030,
	"./assets/icons/video-event_attention.svg": 64729,
	"./assets/icons/video-event_braking.svg": 47383,
	"./assets/icons/video-event_cargo-door-closed.svg": 98913,
	"./assets/icons/video-event_cargo-door-open.svg": 41169,
	"./assets/icons/video-event_collision-warning.svg": 85824,
	"./assets/icons/video-event_danger-maneuver.svg": 45704,
	"./assets/icons/video-event_daydreaming.svg": 66530,
	"./assets/icons/video-event_drinking-water.svg": 29373,
	"./assets/icons/video-event_driver-distraction.svg": 29500,
	"./assets/icons/video-event_drivers-eyes-closed.svg": 97338,
	"./assets/icons/video-event_driving-light-hit.svg": 76097,
	"./assets/icons/video-event_left-turn-while-accelerating.svg": 64169,
	"./assets/icons/video-event_left-turn-while-decelerating.svg": 14664,
	"./assets/icons/video-event_left-turn.svg": 33794,
	"./assets/icons/video-event_no-driver.svg": 57067,
	"./assets/icons/video-event_no-safety-belt.svg": 97267,
	"./assets/icons/video-event_other.svg": 20289,
	"./assets/icons/video-event_over-max-speed.svg": 76452,
	"./assets/icons/video-event_parking-heavy-hit.svg": 16205,
	"./assets/icons/video-event_power-lost.svg": 24351,
	"./assets/icons/video-event_right-turn-while-accelerating.svg": 31046,
	"./assets/icons/video-event_right-turn-while-decelerating.svg": 66519,
	"./assets/icons/video-event_right-turn.svg": 25715,
	"./assets/icons/video-event_sign-violation.svg": 6288,
	"./assets/icons/video-event_smoking.svg": 76081,
	"./assets/icons/video-event_speeding.svg": 83514,
	"./assets/icons/video-event_swerve.svg": 16081,
	"./assets/icons/video-event_talking-on-cell-phone.svg": 5797,
	"./assets/icons/video-event_traffic-light-violation.svg": 31129,
	"./assets/icons/video-event_turn.svg": 17252,
	"./assets/icons/video-event_yawning.svg": 85316,
	"./assets/icons/video-full.svg": 16381,
	"./assets/icons/video-play-popup.svg": 22637,
	"./assets/icons/video-play.svg": 83416,
	"./assets/icons/video-request_done.svg": 53628,
	"./assets/icons/video-request_event.svg": 94196,
	"./assets/icons/video-request_loading.svg": 74952,
	"./assets/icons/video-request_smart-search-accident.svg": 66082,
	"./assets/icons/video-small.svg": 50975,
	"./assets/icons/video-stop.svg": 60202,
	"./assets/icons/video__camera-current.svg": 2906,
	"./assets/icons/video__camera.svg": 36722,
	"./assets/icons/view-document.svg": 37891,
	"./assets/icons/warning-outline.svg": 1193,
	"./assets/icons/warning.svg": 70216,
	"./assets/icons/weather__cloudy-2.svg": 19283,
	"./assets/icons/weather__cloudy.svg": 85826,
	"./assets/icons/weather__day-cloudy-1.svg": 76187,
	"./assets/icons/weather__day-cloudy-2.svg": 60648,
	"./assets/icons/weather__day-cloudy-3.svg": 73017,
	"./assets/icons/weather__day-mostlyc-2.svg": 11185,
	"./assets/icons/weather__day-mostlyc-3.svg": 96800,
	"./assets/icons/weather__day-mostlyc.svg": 41900,
	"./assets/icons/weather__day-rainy-1.svg": 9774,
	"./assets/icons/weather__day-rainy-2.svg": 38893,
	"./assets/icons/weather__day-rainy-3.svg": 59180,
	"./assets/icons/weather__day-snowy-1.svg": 7499,
	"./assets/icons/weather__day-snowy-2.svg": 68664,
	"./assets/icons/weather__day-snowy-3.svg": 27817,
	"./assets/icons/weather__day-thunder-rainy-2.svg": 87896,
	"./assets/icons/weather__day-thunder-rainy-3.svg": 63401,
	"./assets/icons/weather__day-thunder-rainy-4.svg": 36518,
	"./assets/icons/weather__day-thunder.svg": 99713,
	"./assets/icons/weather__day.svg": 34956,
	"./assets/icons/weather__empty.svg": 30481,
	"./assets/icons/weather__night-cloudy-1.svg": 54679,
	"./assets/icons/weather__night-cloudy-2.svg": 228,
	"./assets/icons/weather__night-cloudy-3.svg": 97477,
	"./assets/icons/weather__night-mostlyc-2.svg": 62549,
	"./assets/icons/weather__night-mostlyc-3.svg": 24564,
	"./assets/icons/weather__night-mostlyc.svg": 86904,
	"./assets/icons/weather__night-rainy-1.svg": 14746,
	"./assets/icons/weather__night-rainy-2.svg": 40329,
	"./assets/icons/weather__night-rainy-3.svg": 64824,
	"./assets/icons/weather__night-snowy-1.svg": 45639,
	"./assets/icons/weather__night-snowy-2.svg": 97428,
	"./assets/icons/weather__night-snowy-3.svg": 19061,
	"./assets/icons/weather__night-thunder-rainy-2.svg": 36820,
	"./assets/icons/weather__night-thunder-rainy-3.svg": 74805,
	"./assets/icons/weather__night-thunder-rainy-4.svg": 45706,
	"./assets/icons/weather__night-thunder-rainy.svg": 6821,
	"./assets/icons/weather__night-thunder.svg": 7877,
	"./assets/icons/weather__night.svg": 60320,
	"./assets/icons/weather__precip.svg": 57671,
	"./assets/icons/weather__pressure.svg": 32203,
	"./assets/icons/weather__raindrop.svg": 71339,
	"./assets/icons/weather__rainy-2.svg": 63012,
	"./assets/icons/weather__rainy-3.svg": 17733,
	"./assets/icons/weather__rainy-4.svg": 6106,
	"./assets/icons/weather__rainy.svg": 61621,
	"./assets/icons/weather__snowy-1.svg": 2166,
	"./assets/icons/weather__snowy-2.svg": 15125,
	"./assets/icons/weather__snowy-3.svg": 70196,
	"./assets/icons/weather__snowy-rainy-1.svg": 74498,
	"./assets/icons/weather__snowy-rainy-2.svg": 15249,
	"./assets/icons/weather__snowy-rainy-3.svg": 17216,
	"./assets/icons/weather__snowy-rainy-4.svg": 18335,
	"./assets/icons/weather__thermometer.svg": 19262,
	"./assets/icons/weather__thunder-rainy-2.svg": 87173,
	"./assets/icons/weather__thunder-rainy-3.svg": 32452,
	"./assets/icons/weather__thunder-rainy-4.svg": 94603,
	"./assets/icons/weather__thunder-rainy.svg": 52104,
	"./assets/icons/weather__thunder.svg": 59028,
	"./assets/icons/weather__weather.svg": 75874,
	"./assets/icons/weather__wind.svg": 62324,
	"./assets/icons/wi-fi.svg": 92650,
	"./assets/icons/wizard-info.svg": 20326,
	"./assets/icons/wizard-key.svg": 40947,
	"./assets/icons/wizard-sensors.svg": 36479,
	"./assets/icons/wizard-settings.svg": 23557,
	"./assets/icons/write-edit.svg": 44930,
	"./assets/icons/yogurt.svg": 48410,
	"./assets/image/ETA-fill.svg": 64197,
	"./assets/image/ETA.svg": 9976,
	"./assets/image/arow.png": 28413,
	"./assets/image/bg_reefer-5.png": 13037,
	"./assets/image/bg_reefer.png": 4319,
	"./assets/image/cargo-filling/fill-blue-bottom-10.svg": 65425,
	"./assets/image/cargo-filling/fill-blue-bottom-100.svg": 85395,
	"./assets/image/cargo-filling/fill-blue-bottom-20.svg": 88696,
	"./assets/image/cargo-filling/fill-blue-bottom-30.svg": 35963,
	"./assets/image/cargo-filling/fill-blue-bottom-40.svg": 89194,
	"./assets/image/cargo-filling/fill-blue-bottom-50.svg": 66757,
	"./assets/image/cargo-filling/fill-blue-bottom-60.svg": 11772,
	"./assets/image/cargo-filling/fill-blue-bottom-70.svg": 79999,
	"./assets/image/cargo-filling/fill-blue-bottom-80.svg": 34110,
	"./assets/image/cargo-filling/fill-blue-bottom-90.svg": 68393,
	"./assets/image/cargo-filling/fill-blue-top-10.svg": 83817,
	"./assets/image/cargo-filling/fill-blue-top-100.svg": 55387,
	"./assets/image/cargo-filling/fill-blue-top-20.svg": 99056,
	"./assets/image/cargo-filling/fill-blue-top-30.svg": 83891,
	"./assets/image/cargo-filling/fill-blue-top-40.svg": 71138,
	"./assets/image/cargo-filling/fill-blue-top-50.svg": 9405,
	"./assets/image/cargo-filling/fill-blue-top-60.svg": 78324,
	"./assets/image/cargo-filling/fill-blue-top-70.svg": 19095,
	"./assets/image/cargo-filling/fill-blue-top-80.svg": 44710,
	"./assets/image/cargo-filling/fill-blue-top-90.svg": 97201,
	"./assets/image/cargo-filling/fill-undefined-bottom-100.svg": 9533,
	"./assets/image/cargo-filling/fill-undefined-top-100.svg": 89545,
	"./assets/image/cargo-filling/fill-white-bottom-10.svg": 64312,
	"./assets/image/cargo-filling/fill-white-bottom-100.svg": 8056,
	"./assets/image/cargo-filling/fill-white-bottom-20.svg": 41041,
	"./assets/image/cargo-filling/fill-white-bottom-30.svg": 5830,
	"./assets/image/cargo-filling/fill-white-bottom-40.svg": 99071,
	"./assets/image/cargo-filling/fill-white-bottom-50.svg": 96220,
	"./assets/image/cargo-filling/fill-white-bottom-60.svg": 86053,
	"./assets/image/cargo-filling/fill-white-bottom-70.svg": 22730,
	"./assets/image/cargo-filling/fill-white-bottom-80.svg": 89203,
	"./assets/image/cargo-filling/fill-white-bottom-90.svg": 21776,
	"./assets/image/chassis/Group 3898.svg": 58342,
	"./assets/image/chassis/Group2.svg": 14602,
	"./assets/image/chassis/chassis-12.png": 77565,
	"./assets/image/chassis/chassis-8.png": 89726,
	"./assets/image/chassis/chassis-container-pm.png": 70899,
	"./assets/image/chassis/chassis-container.png": 62483,
	"./assets/image/chassis/error.svg": 57775,
	"./assets/image/chassis/warningsvg.svg": 47741,
	"./assets/image/circle-white.png": 99054,
	"./assets/image/from.svg": 38280,
	"./assets/image/fuel.png": 96502,
	"./assets/image/generatoor-page-bg.png": 58042,
	"./assets/image/generator-1.png": 44925,
	"./assets/image/generator-bg-top.png": 87457,
	"./assets/image/generator-control-1.png": 25541,
	"./assets/image/generator-control-2.png": 71534,
	"./assets/image/generator-control-3.png": 759,
	"./assets/image/generator-main-bg.png": 93669,
	"./assets/image/generator-page-bg-2.png": 2370,
	"./assets/image/generator.png": 40235,
	"./assets/image/gradus.png": 99550,
	"./assets/image/horizont-line.svg": 43974,
	"./assets/image/line-1.svg": 52804,
	"./assets/image/line-2.svg": 57399,
	"./assets/image/line.png": 4728,
	"./assets/image/list-item-1.svg": 12542,
	"./assets/image/list-item-last.svg": 80965,
	"./assets/image/list-item.svg": 60976,
	"./assets/image/main-generator.png": 24773,
	"./assets/image/main-powel-grid.png": 26078,
	"./assets/image/main-switch.png": 63216,
	"./assets/image/new-dashboard-car.png": 26864,
	"./assets/image/no-img-error.png": 81700,
	"./assets/image/no-img-logo.png": 39081,
	"./assets/image/no-img.png": 65161,
	"./assets/image/notes.svg": 53407,
	"./assets/image/proCargoVision.png": 72373,
	"./assets/image/proCargoVision2.png": 83939,
	"./assets/image/sun.png": 45866,
	"./assets/image/temperature.svg": 96334,
	"./assets/image/to.svg": 11083,
	"./assets/image/tok.svg": 30442,
	"./assets/image/unit__reefer.svg": 58599,
	"./assets/image/vertical-line.svg": 98141,
	"./assets/image/video-play.png": 50398,
	"./assets/image/weather__precip.svg": 23451,
	"./assets/image/weather__pressure.svg": 23711,
	"./assets/image/weather__raindrop.svg": 64015,
	"./assets/image/weather__thermometer.svg": 77538,
	"./assets/image/weather__wind.svg": 33528,
	"./assets/img/Reefer.png": 38675,
	"./assets/img/bg-btn-darck.svg": 74708,
	"./assets/img/bg-slider.svg": 78503,
	"./assets/img/car-back.png": 17478,
	"./assets/img/car-front.png": 90242,
	"./assets/img/car-l-side.png": 32775,
	"./assets/img/car-r-side.png": 37497,
	"./assets/img/cargo-truck.png": 9384,
	"./assets/img/circle__clock.svg": 42978,
	"./assets/img/clusters/car_1.png": 80826,
	"./assets/img/clusters/car_2.png": 10993,
	"./assets/img/clusters/car_3.png": 96776,
	"./assets/img/clusters/car_green.png": 77706,
	"./assets/img/clusters/car_red.png": 72654,
	"./assets/img/clusters/car_yellow.png": 14955,
	"./assets/img/clusters/generator_1.png": 88883,
	"./assets/img/clusters/generator_2.png": 14392,
	"./assets/img/clusters/generator_3.png": 87105,
	"./assets/img/clusters/geopoint_1.png": 19681,
	"./assets/img/clusters/geopoint_2.png": 70698,
	"./assets/img/clusters/geopoint_3.png": 25907,
	"./assets/img/clusters/road_green.png": 304,
	"./assets/img/clusters/road_red.png": 26076,
	"./assets/img/clusters/road_yellow.png": 42713,
	"./assets/img/clusters/track_1.png": 32865,
	"./assets/img/clusters/track_1_.png": 9490,
	"./assets/img/clusters/track_1_kph.png": 92771,
	"./assets/img/clusters/track_1_mph.png": 61477,
	"./assets/img/clusters/track_2.png": 2282,
	"./assets/img/clusters/track_2_.png": 32439,
	"./assets/img/clusters/track_2_kph.png": 86628,
	"./assets/img/clusters/track_2_mph.png": 86882,
	"./assets/img/clusters/track_3.png": 57491,
	"./assets/img/clusters/track_3_.png": 46732,
	"./assets/img/clusters/track_3_kph.png": 48509,
	"./assets/img/clusters/track_3_mph.png": 19867,
	"./assets/img/empty.png": 61473,
	"./assets/img/empty1px.png": 43852,
	"./assets/img/events/map__pin-acceleration.png": 92356,
	"./assets/img/events/map__pin-accident.done.svg": 47261,
	"./assets/img/events/map__pin-accident.request.png": 78442,
	"./assets/img/events/map__pin-adas.png": 52843,
	"./assets/img/events/map__pin-attention.png": 26816,
	"./assets/img/events/map__pin-braking.png": 39682,
	"./assets/img/events/map__pin-collision-warning.png": 29701,
	"./assets/img/events/map__pin-danger-maneuver.png": 38205,
	"./assets/img/events/map__pin-door_close.png": 51385,
	"./assets/img/events/map__pin-door_open.png": 38861,
	"./assets/img/events/map__pin-drinking-water.png": 88152,
	"./assets/img/events/map__pin-driver-distraction.png": 85581,
	"./assets/img/events/map__pin-drivers-eyes-closed.png": 59248,
	"./assets/img/events/map__pin-event.png": 45534,
	"./assets/img/events/map__pin-geozone-entrance.png": 52384,
	"./assets/img/events/map__pin-geozone-exit.png": 28554,
	"./assets/img/events/map__pin-geozone_entrance_control.png": 29020,
	"./assets/img/events/map__pin-geozone_exit_control.png": 58078,
	"./assets/img/events/map__pin-health_check.done.png": 39637,
	"./assets/img/events/map__pin-hot_loading.png": 79450,
	"./assets/img/events/map__pin-input-alert.png": 52923,
	"./assets/img/events/map__pin-input.png": 6314,
	"./assets/img/events/map__pin-left-turn-while-accelerating.png": 65468,
	"./assets/img/events/map__pin-left-turn-while-decelerating.png": 15137,
	"./assets/img/events/map__pin-left-turn.png": 31511,
	"./assets/img/events/map__pin-lost-connection.png": 25033,
	"./assets/img/events/map__pin-low-battery.png": 9416,
	"./assets/img/events/map__pin-max-speed.png": 82822,
	"./assets/img/events/map__pin-no-safety-belt.png": 51114,
	"./assets/img/events/map__pin-other.png": 32908,
	"./assets/img/events/map__pin-request_done.png": 98922,
	"./assets/img/events/map__pin-request_event.png": 60884,
	"./assets/img/events/map__pin-request_loading.png": 55784,
	"./assets/img/events/map__pin-right-turn-while-accelerating.png": 33399,
	"./assets/img/events/map__pin-right-turn-while-decelerating.png": 10666,
	"./assets/img/events/map__pin-right-turn.png": 12758,
	"./assets/img/events/map__pin-sign-violation.png": 47709,
	"./assets/img/events/map__pin-smart-search-accident.done.svg": 1246,
	"./assets/img/events/map__pin-smart-search-accident.request.png": 90785,
	"./assets/img/events/map__pin-smart-search.done.png": 59888,
	"./assets/img/events/map__pin-smart-search.request.png": 87717,
	"./assets/img/events/map__pin-smoking.png": 93680,
	"./assets/img/events/map__pin-snapshot.png": 10316,
	"./assets/img/events/map__pin-speeding.png": 45832,
	"./assets/img/events/map__pin-swerve.png": 35072,
	"./assets/img/events/map__pin-talking-on-cell-phone.png": 26800,
	"./assets/img/events/map__pin-temperature.png": 23500,
	"./assets/img/events/map__pin-traffic-light-violation.png": 23200,
	"./assets/img/events/map__pin-turn.png": 29461,
	"./assets/img/events/map__pin-video-event.png": 55072,
	"./assets/img/events/map__pin-yawning.png": 84073,
	"./assets/img/favorite.svg": 11754,
	"./assets/img/fiuel-bg-2.svg": 66070,
	"./assets/img/fiuel-bg.svg": 13763,
	"./assets/img/fiuel-indicator-2.svg": 27696,
	"./assets/img/fiuel-indicator-critical.svg": 26605,
	"./assets/img/fiuel-indicator-danger.svg": 35211,
	"./assets/img/fiuel-indicator-ok.svg": 48020,
	"./assets/img/fiuel-indicator-warn.svg": 56046,
	"./assets/img/fiuel-indicator-warning.svg": 66666,
	"./assets/img/fiuel-indicator.svg": 25785,
	"./assets/img/icons/common__active_color_font-light.svg": 79579,
	"./assets/img/icons/common__active_color_primary-500.svg": 84801,
	"./assets/img/icons/common__block_color_danger.svg": 34597,
	"./assets/img/icons/common__block_color_font-light.svg": 34936,
	"./assets/img/icons/common__delete_lg_color_danger.svg": 63569,
	"./assets/img/icons/common__delete_lg_color_font-light.svg": 10820,
	"./assets/img/icons/common__edit_lg_color_font-light.svg": 56453,
	"./assets/img/icons/common__edit_lg_color_primary-500.svg": 54823,
	"./assets/img/icons/common__follow_sm-light.svg": 64635,
	"./assets/img/icons/common__follow_sm-primary-500.svg": 72499,
	"./assets/img/icons/common__key_revoke_color_font-light.svg": 42799,
	"./assets/img/icons/common__key_revoke_color_primary.svg": 20727,
	"./assets/img/icons/common__key_suspend_color_font-light.svg": 61573,
	"./assets/img/icons/common__key_suspend_color_primary.svg": 69385,
	"./assets/img/icons/common__password_color_font-light.svg": 18272,
	"./assets/img/icons/common__password_color_primary-500.svg": 83664,
	"./assets/img/icons/common__refresh_color_font-light.svg": 87714,
	"./assets/img/icons/common__refresh_color_primary-500.svg": 36814,
	"./assets/img/icons/common__restore_color_font-light.svg": 68863,
	"./assets/img/icons/common__restore_color_primary-500.svg": 46325,
	"./assets/img/icons/common__sign_in_admin_color_font-light.svg": 65240,
	"./assets/img/icons/common__sign_in_admin_color_primary-500.svg": 42392,
	"./assets/img/icons/common__sign_in_portal_color_font-light.svg": 88565,
	"./assets/img/icons/common__sign_in_portal_color_primary-500.svg": 87127,
	"./assets/img/icons/common__update_key_color_font-light.svg": 27748,
	"./assets/img/icons/common__update_key_color_primary-500.svg": 52628,
	"./assets/img/icons/write-edit.svg": 73857,
	"./assets/img/input__close.svg": 91744,
	"./assets/img/input__select.svg": 48836,
	"./assets/img/leaflet/marker-icon.png": 12896,
	"./assets/img/leaflet/marker_geopoint.png": 51862,
	"./assets/img/location.svg": 9195,
	"./assets/img/locator-shipment-bg.png": 50153,
	"./assets/img/logo.svg": 67503,
	"./assets/img/logos/TRINITY.svg": 50958,
	"./assets/img/logos/xCargo-powerid.svg": 54326,
	"./assets/img/logos/xCargo.svg": 71837,
	"./assets/img/money_cart.svg": 87011,
	"./assets/img/not-video.svg": 22383,
	"./assets/img/playBackEvents/command_ClearAlarms.svg": 87656,
	"./assets/img/playBackEvents/command_PerformPreTrip.svg": 84512,
	"./assets/img/playBackEvents/command_RecoveryOff.svg": 27453,
	"./assets/img/playBackEvents/command_RecoveryOn.svg": 19241,
	"./assets/img/playBackEvents/command_RemoteOff.svg": 55892,
	"./assets/img/playBackEvents/command_RemoteOn.svg": 91422,
	"./assets/img/playBackEvents/command_SetTemperature.svg": 17937,
	"./assets/img/playBackEvents/command_StartDefrost.svg": 91990,
	"./assets/img/playBackEvents/door-close-open.svg": 58571,
	"./assets/img/playBackEvents/door-open-close.svg": 60061,
	"./assets/img/playBackEvents/empty.svg": 84148,
	"./assets/img/playBackEvents/event_ble_connect.svg": 20090,
	"./assets/img/playBackEvents/event_ble_disconnect.svg": 37694,
	"./assets/img/playBackEvents/event_ble_group.svg": 79145,
	"./assets/img/playBackEvents/event_chassis_loaded.svg": 76966,
	"./assets/img/playBackEvents/event_chassis_unloaded.svg": 84955,
	"./assets/img/playBackEvents/event_door_close.svg": 75639,
	"./assets/img/playBackEvents/event_door_open.svg": 95849,
	"./assets/img/playBackEvents/event_hot_loading.png": 48484,
	"./assets/img/playBackEvents/event_hot_loading.svg": 37826,
	"./assets/img/playBackEvents/event_loaded.prometheus.svg": 9673,
	"./assets/img/playBackEvents/event_loaded.svg": 6813,
	"./assets/img/playBackEvents/event_refills.svg": 46513,
	"./assets/img/playBackEvents/event_snapshot.svg": 22350,
	"./assets/img/playBackEvents/event_temperature.svg": 1060,
	"./assets/img/playBackEvents/event_tire_alert.svg": 54155,
	"./assets/img/playBackEvents/event_tire_alert.tire.pressure.down.svg": 29690,
	"./assets/img/playBackEvents/event_tire_alert.tire.pressure.up.svg": 90665,
	"./assets/img/playBackEvents/event_tire_alert.tire.svg": 81737,
	"./assets/img/playBackEvents/event_tire_alert_pressure_down.svg": 74930,
	"./assets/img/playBackEvents/event_tire_alert_pressure_up.svg": 97569,
	"./assets/img/playBackEvents/event_tire_alert_punctured.svg": 44660,
	"./assets/img/playBackEvents/event_unloaded.prometheus.svg": 67522,
	"./assets/img/playBackEvents/event_unloaded.svg": 37112,
	"./assets/img/playBackEvents/manual.svg": 52771,
	"./assets/img/playBackEvents/playback__video-event-1.svg": 97720,
	"./assets/img/playBackEvents/playback__video-event-2.svg": 48459,
	"./assets/img/playBackEvents/playback__video-event-3.svg": 33850,
	"./assets/img/playBackEvents/playback__video-group.svg": 84383,
	"./assets/img/playBackEvents/playback__warn-event.svg": 13379,
	"./assets/img/playBackEvents/theme-dark/command_RecoveryOff.svg": 49958,
	"./assets/img/playBackEvents/theme-dark/command_RecoveryOn.svg": 6672,
	"./assets/img/playBackEvents/theme-dark/event_ble_connect.svg": 57913,
	"./assets/img/playBackEvents/theme-dark/event_ble_disconnect.svg": 60759,
	"./assets/img/playBackEvents/theme-dark/event_ble_group.svg": 90074,
	"./assets/img/playBackEvents/theme-dark/event_chassis_loaded.svg": 71391,
	"./assets/img/playBackEvents/theme-dark/event_chassis_unloaded.svg": 87318,
	"./assets/img/playBackEvents/theme-dark/event_door_close.svg": 53074,
	"./assets/img/playBackEvents/theme-dark/event_door_open.svg": 90222,
	"./assets/img/playBackEvents/theme-dark/event_refills.svg": 55338,
	"./assets/img/playBackEvents/theme-dark/event_snapshot.svg": 48223,
	"./assets/img/playBackEvents/theme-dark/event_tire_alert.svg": 6710,
	"./assets/img/playBackEvents/theme-dark/event_tire_alert_pressure_down.svg": 95395,
	"./assets/img/playBackEvents/theme-dark/event_tire_alert_pressure_up.svg": 91644,
	"./assets/img/playBackEvents/theme-dark/event_tire_alert_punctured.svg": 18869,
	"./assets/img/playBackEvents/theme-dark/playback__video-group.svg": 15260,
	"./assets/img/playBackEvents/theme-dark/playback__warn-event.svg": 68086,
	"./assets/img/playBackEvents/theme-dark/video-event_acceleration.svg": 96973,
	"./assets/img/playBackEvents/theme-dark/video-event_accident.svg": 72906,
	"./assets/img/playBackEvents/theme-dark/video-event_accident2.svg": 41140,
	"./assets/img/playBackEvents/theme-dark/video-event_attention.svg": 19509,
	"./assets/img/playBackEvents/theme-dark/video-event_braking.svg": 37611,
	"./assets/img/playBackEvents/theme-dark/video-event_cargo-door-closed.svg": 21773,
	"./assets/img/playBackEvents/theme-dark/video-event_cargo-door-open.svg": 8693,
	"./assets/img/playBackEvents/theme-dark/video-event_collision-warning.svg": 34244,
	"./assets/img/playBackEvents/theme-dark/video-event_danger-maneuver.svg": 65236,
	"./assets/img/playBackEvents/theme-dark/video-event_drinking-water.svg": 18393,
	"./assets/img/playBackEvents/theme-dark/video-event_driver-distraction.svg": 62768,
	"./assets/img/playBackEvents/theme-dark/video-event_drivers-eyes-closed.svg": 26982,
	"./assets/img/playBackEvents/theme-dark/video-event_left-turn-while-accelerating.svg": 11437,
	"./assets/img/playBackEvents/theme-dark/video-event_left-turn-while-decelerating.svg": 4332,
	"./assets/img/playBackEvents/theme-dark/video-event_left-turn.svg": 54182,
	"./assets/img/playBackEvents/theme-dark/video-event_no-safety-belt.svg": 98831,
	"./assets/img/playBackEvents/theme-dark/video-event_other.svg": 99277,
	"./assets/img/playBackEvents/theme-dark/video-event_right-turn-while-accelerating.svg": 24018,
	"./assets/img/playBackEvents/theme-dark/video-event_right-turn-while-decelerating.svg": 80995,
	"./assets/img/playBackEvents/theme-dark/video-event_right-turn.svg": 50159,
	"./assets/img/playBackEvents/theme-dark/video-event_sign-violation.svg": 64164,
	"./assets/img/playBackEvents/theme-dark/video-event_smoking.svg": 14341,
	"./assets/img/playBackEvents/theme-dark/video-event_speeding.svg": 53902,
	"./assets/img/playBackEvents/theme-dark/video-event_swerve.svg": 68621,
	"./assets/img/playBackEvents/theme-dark/video-event_talking-on-cell-phone.svg": 21921,
	"./assets/img/playBackEvents/theme-dark/video-event_traffic-light-violation.svg": 35869,
	"./assets/img/playBackEvents/theme-dark/video-event_turn.svg": 62728,
	"./assets/img/playBackEvents/theme-dark/video-event_yawning.svg": 1720,
	"./assets/img/playBackEvents/theme-dark/video-request_accident.done.svg": 44659,
	"./assets/img/playBackEvents/theme-dark/video-request_accident.loading.svg": 98109,
	"./assets/img/playBackEvents/theme-dark/video-request_accident.request.svg": 86534,
	"./assets/img/playBackEvents/theme-dark/video-request_accident.svg": 65611,
	"./assets/img/playBackEvents/theme-dark/video-request_cargo_snapshot.svg": 55923,
	"./assets/img/playBackEvents/theme-dark/video-request_cargo_snapshots.svg": 79962,
	"./assets/img/playBackEvents/theme-dark/video-request_done.svg": 26256,
	"./assets/img/playBackEvents/theme-dark/video-request_event.svg": 30984,
	"./assets/img/playBackEvents/theme-dark/video-request_face_recognition.done.svg": 90371,
	"./assets/img/playBackEvents/theme-dark/video-request_face_recognition.loading.svg": 81805,
	"./assets/img/playBackEvents/theme-dark/video-request_health_check.done.svg": 38271,
	"./assets/img/playBackEvents/theme-dark/video-request_health_check.loading.svg": 43657,
	"./assets/img/playBackEvents/theme-dark/video-request_insurance-report-started.svg": 29319,
	"./assets/img/playBackEvents/theme-dark/video-request_insurance-report-submitted.svg": 73327,
	"./assets/img/playBackEvents/theme-dark/video-request_insurance-report.svg": 54343,
	"./assets/img/playBackEvents/theme-dark/video-request_loading.svg": 14140,
	"./assets/img/playBackEvents/theme-dark/video-request_manualbackup.done.svg": 54086,
	"./assets/img/playBackEvents/theme-dark/video-request_manualbackup.loading.svg": 706,
	"./assets/img/playBackEvents/theme-dark/video-request_request.done.svg": 45187,
	"./assets/img/playBackEvents/theme-dark/video-request_request.loading.svg": 94253,
	"./assets/img/playBackEvents/theme-dark/video-request_smart-search-accident.done.svg": 7084,
	"./assets/img/playBackEvents/theme-dark/video-request_smart-search-accident.loading.svg": 29496,
	"./assets/img/playBackEvents/theme-dark/video-request_smart-search-accident.request.svg": 67631,
	"./assets/img/playBackEvents/theme-dark/video-request_smart-search-accident.svg": 91782,
	"./assets/img/playBackEvents/theme-dark/video-request_smart-search.done.svg": 30902,
	"./assets/img/playBackEvents/theme-dark/video-request_smart-search.loading.svg": 52082,
	"./assets/img/playBackEvents/theme-dark/video-request_time_caps-accident.loading.svg": 36079,
	"./assets/img/playBackEvents/theme-dark/video-request_time_caps.done-accident.svg": 84141,
	"./assets/img/playBackEvents/theme-dark/video-request_time_caps.done.svg": 94849,
	"./assets/img/playBackEvents/theme-dark/video-request_time_caps.loading.svg": 83907,
	"./assets/img/playBackEvents/vide-event_cyclist-collision.svg": 81953,
	"./assets/img/playBackEvents/vide-event_distracted.svg": 12894,
	"./assets/img/playBackEvents/vide-event_pedestrian-collision.svg": 53419,
	"./assets/img/playBackEvents/video-event_acceleration.svg": 26116,
	"./assets/img/playBackEvents/video-event_accident.svg": 90555,
	"./assets/img/playBackEvents/video-event_accident2.svg": 44579,
	"./assets/img/playBackEvents/video-event_attention.svg": 12690,
	"./assets/img/playBackEvents/video-event_braking.svg": 40516,
	"./assets/img/playBackEvents/video-event_cargo-door-closed.svg": 74354,
	"./assets/img/playBackEvents/video-event_cargo-door-open.svg": 18574,
	"./assets/img/playBackEvents/video-event_collision-warning.svg": 45843,
	"./assets/img/playBackEvents/video-event_danger-maneuver.svg": 27403,
	"./assets/img/playBackEvents/video-event_daydreaming.svg": 32465,
	"./assets/img/playBackEvents/video-event_distracted.svg": 71505,
	"./assets/img/playBackEvents/video-event_drinking-water.svg": 26940,
	"./assets/img/playBackEvents/video-event_driver-distraction.svg": 50741,
	"./assets/img/playBackEvents/video-event_drivers-eyes-closed.svg": 26885,
	"./assets/img/playBackEvents/video-event_driving-heavy-hit.svg": 58619,
	"./assets/img/playBackEvents/video-event_driving-light-hit.svg": 6842,
	"./assets/img/playBackEvents/video-event_driving-suspicious-hit.svg": 9275,
	"./assets/img/playBackEvents/video-event_left-turn-while-accelerating.svg": 5008,
	"./assets/img/playBackEvents/video-event_left-turn-while-decelerating.svg": 38941,
	"./assets/img/playBackEvents/video-event_left-turn.svg": 84297,
	"./assets/img/playBackEvents/video-event_low-battery.svg": 13858,
	"./assets/img/playBackEvents/video-event_no-driver.svg": 50392,
	"./assets/img/playBackEvents/video-event_no-safety-belt.svg": 33886,
	"./assets/img/playBackEvents/video-event_other.svg": 39966,
	"./assets/img/playBackEvents/video-event_over-max-speed.svg": 13717,
	"./assets/img/playBackEvents/video-event_parking-heavy-hit.svg": 10630,
	"./assets/img/playBackEvents/video-event_parking-hit.svg": 78984,
	"./assets/img/playBackEvents/video-event_passengers-inside.svg": 70064,
	"./assets/img/playBackEvents/video-event_passengers-no-seatbelt.svg": 60122,
	"./assets/img/playBackEvents/video-event_power-lost.svg": 52246,
	"./assets/img/playBackEvents/video-event_right-turn-while-accelerating.svg": 19954,
	"./assets/img/playBackEvents/video-event_right-turn-while-decelerating.svg": 10071,
	"./assets/img/playBackEvents/video-event_right-turn.svg": 48334,
	"./assets/img/playBackEvents/video-event_sign-violation.svg": 25693,
	"./assets/img/playBackEvents/video-event_smoking.svg": 23750,
	"./assets/img/playBackEvents/video-event_speeding.svg": 76439,
	"./assets/img/playBackEvents/video-event_stop-sing-violation.svg": 88030,
	"./assets/img/playBackEvents/video-event_swerve.svg": 69148,
	"./assets/img/playBackEvents/video-event_talking-on-cell-phone.svg": 33174,
	"./assets/img/playBackEvents/video-event_traffic-light-violation.svg": 40514,
	"./assets/img/playBackEvents/video-event_turn.svg": 40653,
	"./assets/img/playBackEvents/video-event_yawning.svg": 6099,
	"./assets/img/playBackEvents/video-request_accident.done.svg": 38516,
	"./assets/img/playBackEvents/video-request_accident.insurance-report.svg": 68987,
	"./assets/img/playBackEvents/video-request_accident.loading.svg": 42192,
	"./assets/img/playBackEvents/video-request_accident.svg": 77582,
	"./assets/img/playBackEvents/video-request_cargo_snapshot.svg": 32590,
	"./assets/img/playBackEvents/video-request_cargo_snapshots.svg": 97297,
	"./assets/img/playBackEvents/video-request_done.svg": 82865,
	"./assets/img/playBackEvents/video-request_door_close.svg": 73156,
	"./assets/img/playBackEvents/video-request_door_open.svg": 94792,
	"./assets/img/playBackEvents/video-request_event.svg": 40959,
	"./assets/img/playBackEvents/video-request_face_recognition.done.svg": 31096,
	"./assets/img/playBackEvents/video-request_face_recognition.loading.svg": 32564,
	"./assets/img/playBackEvents/video-request_health_check.done.svg": 604,
	"./assets/img/playBackEvents/video-request_health_check.loading.svg": 35016,
	"./assets/img/playBackEvents/video-request_insurance-report-started.svg": 42526,
	"./assets/img/playBackEvents/video-request_insurance-report-submitted.svg": 24322,
	"./assets/img/playBackEvents/video-request_insurance-report.svg": 82178,
	"./assets/img/playBackEvents/video-request_loading.svg": 69363,
	"./assets/img/playBackEvents/video-request_manualbackup.done.svg": 1657,
	"./assets/img/playBackEvents/video-request_manualbackup.loading.svg": 99179,
	"./assets/img/playBackEvents/video-request_request.done.svg": 58982,
	"./assets/img/playBackEvents/video-request_request.loading.svg": 15938,
	"./assets/img/playBackEvents/video-request_smart-search-accident.done.svg": 32009,
	"./assets/img/playBackEvents/video-request_smart-search-accident.loading.svg": 70715,
	"./assets/img/playBackEvents/video-request_smart-search-accident.svg": 27593,
	"./assets/img/playBackEvents/video-request_smart-search.done.svg": 84669,
	"./assets/img/playBackEvents/video-request_smart-search.loading.svg": 69615,
	"./assets/img/playBackEvents/video-request_snapshot.svg": 63533,
	"./assets/img/playBackEvents/video-request_time_caps-accident.done.svg": 78158,
	"./assets/img/playBackEvents/video-request_time_caps-accident.loading.svg": 4218,
	"./assets/img/playBackEvents/video-request_time_caps.done.svg": 24488,
	"./assets/img/playBackEvents/video-request_time_caps.loading.svg": 87172,
	"./assets/img/product_logo.png": 62985,
	"./assets/img/reefer-icon/reefer.png": 65157,
	"./assets/img/reefer-icon/reefer__carrier.png": 8271,
	"./assets/img/reefer-icon/reefer__king.png": 76406,
	"./assets/img/reefer-icon/refeer-right.png": 64754,
	"./assets/img/reefer-icon/thermo-king.png": 88707,
	"./assets/img/services/ApolloELD.png": 1531,
	"./assets/img/services/ComplianceBox.png": 16721,
	"./assets/img/services/Fleetio.png": 71749,
	"./assets/img/services/Nocell.png": 23748,
	"./assets/img/services/WliusELD.png": 85678,
	"./assets/img/shipments/alerts_arrival.svg": 51153,
	"./assets/img/shipments/alerts_battery_max.svg": 242,
	"./assets/img/shipments/alerts_battery_min.svg": 19124,
	"./assets/img/shipments/alerts_departure.svg": 12810,
	"./assets/img/shipments/alerts_humidity_max.svg": 31862,
	"./assets/img/shipments/alerts_humidity_min.svg": 80336,
	"./assets/img/shipments/alerts_temperature_max.svg": 58367,
	"./assets/img/shipments/alerts_temperature_min.svg": 33593,
	"./assets/img/shipments/eta.svg": 94174,
	"./assets/img/shipments/manually-start-shipment.svg": 78237,
	"./assets/img/shipments/playback__video-group.svg": 60778,
	"./assets/img/shipments/shipment__box.png": 48337,
	"./assets/img/shipments/shipment__box.svg": 5665,
	"./assets/img/shipments/shipment__container.png": 93711,
	"./assets/img/shipments/shipment__container.svg": 28655,
	"./assets/img/shipments/shipment__documents.svg": 90248,
	"./assets/img/shipments/shipment__food.png": 12575,
	"./assets/img/shipments/shipment__food.svg": 95394,
	"./assets/img/shipments/shipment__group.svg": 17123,
	"./assets/img/shipments/shipment__mail.png": 55949,
	"./assets/img/shipments/shipment__mail.svg": 15935,
	"./assets/img/shipments/shipment__pallet.svg": 61840,
	"./assets/img/shipments/shipment__pallete.png": 25641,
	"./assets/img/shipments/shipment__pallete.svg": 14877,
	"./assets/img/shipments/shipment__point.svg": 24872,
	"./assets/img/shipments/shipment__temperature.svg": 51116,
	"./assets/img/shipments/shipment_end.svg": 23790,
	"./assets/img/shipments/shipment_reports.svg": 24560,
	"./assets/img/shipments/shipment_start.svg": 49509,
	"./assets/img/shipments/warning.svg": 81526,
	"./assets/img/slider-dot-handle_bg.svg": 47348,
	"./assets/img/test-video.png": 29370,
	"./assets/img/track/direction-icon.svg": 98014,
	"./assets/img/track/flag_finish.png": 45738,
	"./assets/img/track/flag_start.png": 94403,
	"./assets/img/track/map__pin-a-point.png": 16754,
	"./assets/img/track/map__pin-accelerate.png": 49043,
	"./assets/img/track/map__pin-accident.done.png": 17897,
	"./assets/img/track/map__pin-accident.loading.png": 63893,
	"./assets/img/track/map__pin-b-point.png": 85689,
	"./assets/img/track/map__pin-door-close.png": 90419,
	"./assets/img/track/map__pin-door-open.png": 85127,
	"./assets/img/track/map__pin-event.png": 9054,
	"./assets/img/track/map__pin-hot_loading.png": 26234,
	"./assets/img/track/map__pin-insurance-report.png": 40151,
	"./assets/img/track/map__pin-lost-connection.png": 18505,
	"./assets/img/track/map__pin-low-battery.png": 73736,
	"./assets/img/track/map__pin-max-speed.png": 48134,
	"./assets/img/track/map__pin-parking.png": 23630,
	"./assets/img/track/map__pin-shock.png": 33848,
	"./assets/img/track/map__pin-smart-search-accident.done.png": 77972,
	"./assets/img/track/map__pin-smart-search-accident.loading.png": 96306,
	"./assets/img/track/map__pin-smart-search.done.png": 72976,
	"./assets/img/track/map__pin-smart-search.loading.png": 85934,
	"./assets/img/track/map__pin-stop.png": 59660,
	"./assets/img/track/map__pin-temperature.png": 460,
	"./assets/img/track/map__pin-turn.png": 15509,
	"./assets/img/track/map__pin-warning.png": 25062,
	"./assets/img/track/parking.png": 86442,
	"./assets/img/track/stop.png": 94976,
	"./assets/img/unit/common__boat_lg.png": 6173,
	"./assets/img/unit/common__bus_lg.png": 97904,
	"./assets/img/unit/common__car.png": 55614,
	"./assets/img/unit/common__car_lg.png": 32976,
	"./assets/img/unit/common__complex_lg.png": 27578,
	"./assets/img/unit/common__dry_trailer_lg.png": 51375,
	"./assets/img/unit/common__engine_lg.png": 37574,
	"./assets/img/unit/common__fuel_tank_lg.png": 69019,
	"./assets/img/unit/common__fuel_tanker_lg.png": 58764,
	"./assets/img/unit/common__generator_lg.png": 90891,
	"./assets/img/unit/common__jet_ski_lg.png": 95263,
	"./assets/img/unit/common__motorcycle_lg.png": 1397,
	"./assets/img/unit/common__plant_machine_lg.png": 13805,
	"./assets/img/unit/common__pump_lg.png": 80410,
	"./assets/img/unit/common__reefer_gt_lg.png": 91375,
	"./assets/img/unit/common__reefer_trailer_lg.png": 7141,
	"./assets/img/unit/common__rv_lg.png": 78812,
	"./assets/img/unit/common__stationary_unit_lg.png": 69371,
	"./assets/img/unit/common__tank_lg.png": 35156,
	"./assets/img/unit/common__tractor_lg.png": 52473,
	"./assets/img/unit/common__train_lg.png": 99808,
	"./assets/img/unit/common__truck_lg.png": 86693,
	"./assets/img/unit/common__van_lg.png": 83807,
	"./assets/img/unit/common__water_tanker_lg.png": 6891,
	"./assets/img/unit/map__car_type_ambulance.svg": 42403,
	"./assets/img/unit/map__car_type_motorbike.svg": 80441,
	"./assets/img/unit/map__car_type_pickup.svg": 70531,
	"./assets/img/unit/map__car_type_police.svg": 69165,
	"./assets/img/unit/map__car_type_sedan.svg": 43620,
	"./assets/img/unit/map__car_type_taxi.svg": 24039,
	"./assets/img/unit/map__car_type_truck.svg": 10188,
	"./assets/img/video-event_other.svg": 23787,
	"./assets/img/video-spinner.gif": 29520,
	"./assets/img/warning.svg": 6426,
	"./assets/logo/geotab-mini.svg": 51330,
	"./assets/logo/intuit.png": 61033,
	"./assets/logo/logo.svg": 19419,
	"./assets/logo/prometheus.png": 69610,
	"./assets/poster/driver.png": 85758,
	"./assets/poster/poster-1.png": 88849,
	"./assets/poster/poster-2.png": 67738,
	"./assets/poster/poster-3.png": 31843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15353;